import { StyledMyAttendancesMenu } from "./style";
import { useContext, useEffect, useState } from "react";
import { AttendancesContext } from "../../../../contexts/user/AttendancesContext";
import { AttendanceItem } from "./AttendanceItem";
import removeChars from "../../../../Hooks/removeChars.util";
import { FaComments, FaSearch } from "react-icons/fa";
import Input from "../../../../components/Input";
import { defaultInput100 } from "../../../../components-variants/defaultInputs";
import { CustomState } from "../../../../Hooks/State.hook";
import { Pagination } from "@mui/material";

export const MyAttendancesMenu = () => {
    const { detailedAttendances } = useContext(AttendancesContext);
    const { newAttendanceModalState } = useContext(AttendancesContext);
    const [filter, setFilter] = useState("");
    const currentPage = CustomState<number>(1);
    const ITEMS_PER_PAGE = 30;

    const sortedAttendances = function () {
        return detailedAttendances.value;
    }();

    const filteredSortedAttendances = function () {
        return sortedAttendances.filter((a) => {
            return String(a.CODIGO || "") === filter ||
                String(a.COD_ERP || "") === filter ||
                String(a.CODIGO_CLIENTE || "") === filter ||
                String(a.CODIGO_NUMERO || "") === filter ||
                a.CONTATO_NOME?.toUpperCase().includes(filter) ||
                a.CONTATO_NUMERO?.includes(removeChars(filter, "+_() ")) ||
                removeChars((a.RAZAO || "").toUpperCase(), " ").includes(removeChars(filter, " ")) ||
                a.CPF_CNPJ?.includes(removeChars(filter, "-. "))
        });
    }();

    useEffect(() => {
        currentPage.set(1);
    }, [filter]);

    return (
        <StyledMyAttendancesMenu>
            <div className="filter">
                <Input
                    placeholder="Filtrar atendimentos..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value.toUpperCase())}
                    {...defaultInput100}
                    $fontSize={0.875}
                    leftIcon={<FaSearch />}
                />
                <button type="button" onClick={() => newAttendanceModalState.set(true)}>
                    <FaComments />
                    Novo atendimento
                </button>
            </div>
            <div className="results">
                <ul>
                    {
                        filteredSortedAttendances
                            .map((a) => <AttendanceItem attendance={a} key={`a_${a.CODIGO}`} />)
                            .slice((currentPage.value - 1) * ITEMS_PER_PAGE, currentPage.value * ITEMS_PER_PAGE)
                    }
                </ul>
            </div>
            <div className="page-navigation">
                <Pagination
                    count={Math.ceil(filteredSortedAttendances.length / ITEMS_PER_PAGE)}
                    showFirstButton
                    showLastButton
                    page={currentPage.value}
                    onChange={(_, v) => currentPage.set(v)}
                    size="small"
                />
            </div>
        </StyledMyAttendancesMenu>
    );
};